import React, { useRef, useEffect } from "react";

const AudioVisualiser = ({ audio }) => {
  const canvas = useRef(null);

  const drow = () => {
    const audioData = audio;
    const canvass = canvas.current;
    const height = canvass.height;
    const width = canvass.width;
    const context = canvass.getContext("2d");
    let x = 0;
    const sliceWidth = (width * 1.0) / audioData.length;
    context.lineWidth = 2;
    context.strokeStyle = "#841474";
    context.clearRect(0, 0, width, height);
    context.beginPath();
    context.moveTo(0, height / 2);
    for (const item of audioData) {
      const y = (item / 225.0) * height;
      context.lineTo(x, y);
      x += sliceWidth;
    }
    context.lineTo(x, height / 2);
    context.stroke();
  };

  useEffect(() => {
    drow();
  });

  return (
    <canvas
      className="AudioVisualiser_canvas"
      width="180px"
      height="38px"
      ref={canvas}
    />
  );
};

export default AudioVisualiser;
